// https://tiptap.dev/docs/editor/core-concepts/introduction
import { EditorContent, useEditor } from '@tiptap/react';
import { useEffect } from 'react';

import { extensions } from '../../extensions';
import { parseContentFromSchema } from '../../utils/parse-content-from-schema';

import '../../styles.css';
import styles from '../../styles.module.css';

const editorProps = {
  attributes: {
    class: styles['editor-content'],
  },
};

interface EditorProps {
  content?: string;
}

/**
 * Editor
 * @param content **optional** Initializes with rich text or update all content.
 */
export function EditorReadonly({ content }: EditorProps) {
  const editor = useEditor({
    editable: false,
    editorProps,
    extensions: extensions({}),
    injectCSS: true,
  });

  useEffect(() => {
    if (!editor) return;
    editor.commands.setContent(parseContentFromSchema({ content, editor }));
  }, [content, editor]);

  if (!editor) return null;

  return (
    <div className="rounded-lg border border-border">
      <EditorContent editor={editor} />
    </div>
  );
}
